import { BaseDto } from '@/core';

export class SpaceTypeSearchDto extends BaseDto<SpaceTypeSearchDto> {
  companyDistrictNo: string | number;
}
